export const VALenderMortgageeIDCode = "018143-00-00";
export const VASponsorAgentIDCode = "7403220000";
